<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="$emit('close')")
        .battle-title(slot="header") {{ battle.name }}
        .battle-body
            .battle-stage(v-for="stage in battle.levels[0].stages")
                .battle-stage-title(@click="openStage(stage.position)")
                    span {{ $i18n.t('olympiads.olympiads_stageForm_stage') }} {{ stage.position + 1 }}
                    svg-icon.battle-stage-arrow(
                        :name="stage.position === openedStageIndex ? 'angle-up' : 'angle-down'",
                        size="large",
                    )
                .battle-stage-game(v-for="game in stage.games", v-if="stage.position === openedStageIndex")
                    .battle-stage-game__name {{ getGameName(game) }}
                    div(:is="getType(game.slug)", :parameters="game.parameters.default", :type="game.slug")
                    divider(:margin="'0'")
        .battle-button
            cs-button(type="button", :disabled='inappropriateDeviceForNavigatorGame', color="blue", @click="$emit('showListOpponents', battle.id)")
                | {{ $i18n.t('battle.battle_start') }}
        .battle-footer(slot="footer")
            span {{ $i18n.t('battle.battle_rules') }}
            a(:href="battle.rulesLink" target="_blank") {{ $i18n.t('battle.battle_click_here') }}
</template>

<script>
    /*eslint-disable*/
    import FlashCards from '../../trainer/browse/FlashCards.vue';
    import AdditionAndSubtraction from '../../trainer/browse/AddSub.vue';
    import MultiplicationAndDivision from '../../trainer/browse/MultiplicationAndDivision.vue';
    import Equation from '../../trainer/browse/Equation.vue';
    import Anzan from '../../trainer/browse/Anzan.vue';
    import Schulte from '../../trainer/browse/Schulte.vue';
    import Navigator from '../../trainer/browse/Navigator.vue';
    import Puzzle from '../../trainer/browse/Puzzle.vue';
    import TransferSyllables from '../../trainer/browse/TransferSyllables.vue';
    import HardSoftConsonants from '../../trainer/browse/HardSoftConsonants.vue';
    import DivideItRight from '../../trainer/browse/DivideItRight.vue';
    import ChooseItRight from '../../trainer/browse/ChooseItRight.vue';
    import DivideUnstressedVowels from '../../trainer/browse/DivideUnstressedVowels.vue';
    import WordStructure from '../../trainer/browse/WordStructure.vue';
    import SentenceParsing from "../../trainer/browse/SentenceParsing.vue";
    import VocabularyWordsRus from '../../trainer/browse/VocabularyWordsRus.vue';
    import TranscriptionInWord from '../../trainer/browse/TranscriptionInWord.vue';
    import LettersSoundsSyllables from '../../trainer/browse/LettersSoundsSyllables.vue';
    import VoicedAndDeafConsonants from '../../trainer/browse/VoicedAndDeafConsonants.vue';
    import PartsOfSpeech from '../../trainer/browse/PartsOfSpeech.vue';
    import ParsingSentencePartsSpeech from '../../trainer/browse/ParsingSentencePartsSpeech.vue';
    import GenericWords from '../../trainer/browse/GenericWords.vue';
    import VerbTenses from '../../trainer/browse/VerbTenses.vue';
    import SortOneMany from '../../trainer/browse/SortOneMany.vue';
    import PunctuationMarks from '../../trainer/browse/PunctuationMarks.vue';
    import Alphabet from '../../trainer/browse/Alphabet.vue';
    import ConnectThePuzzles from '../../trainer/browse/ConnectThePuzzles.vue';
    import Orthograph from '../../trainer/browse/Orthograph.vue';

    import getType from '../../../utils/trainer/getType';
    import { camelCase } from 'lodash';
    import TrainerUtilities from '../../../utils/trainer/trainer';

    export default {
        mixins: [getType, TrainerUtilities],
        props: {
            battle: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                openedStageIndex: null,
            };
        },
        methods: {
            openStage(index) {
                this.openedStageIndex = index === this.openedStageIndex ? null : index;
            },
            getTranslationKey(slug) {
                return camelCase(slug);
            },
        },
        computed: {
            inappropriateDeviceForNavigatorGame() {
                let currentWidth = window.innerWidth;
                return (
                    currentWidth < 768 &&
                    !!this.battle.levels.find(level => {
                        return level.stages.find(stage => {
                            return stage.games.find(game => {
                                return game.slug === 'Navigator' && game.parameters.default.difficult > 7;
                            });
                        });
                    })
                );
            },
        },
        components: {
            FlashCards,
            AdditionAndSubtraction,
            MultiplicationAndDivision,
            Equation,
            Anzan,
            Schulte,
            Navigator,
            Puzzle,
            TransferSyllables,
            HardSoftConsonants,
            DivideItRight,
            ChooseItRight,
            DivideUnstressedVowels,
            WordStructure,
            SentenceParsing,
            VocabularyWordsRus,
            TranscriptionInWord,
            LettersSoundsSyllables,
            VoicedAndDeafConsonants,
            PartsOfSpeech,
            ParsingSentencePartsSpeech,
            GenericWords,
            VerbTenses,
            SortOneMany,
            PunctuationMarks,
            Alphabet,
            ConnectThePuzzles,
            Orthograph,
        },
    };
</script>

<style scoped lang="scss">
    .battle-title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: #333333;
        margin: 30px;
    }
    .battle-stage-title {
        cursor: pointer;
        box-sizing: border-box;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: #333333;
        text-align: left;
        height: 70px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 100%;
        background: #f7f7ff;
        border-radius: 10px;
        padding: 0 20px 0 20px;
        align-items: center;
    }
    .battle-stage-arrow {
        color: $hsl-color-blue-56;
        @media screen and (max-width: 360px) {
            display: none;
        }
    }
    .battle-stage {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 30px;
        border: 1px solid #f2f2ff;
        box-sizing: border-box;
        border-radius: 10px;
        @media screen and (max-width: 400px) {
            margin: 15px;
        }
    }
    .battle-stage-game {
        display: flex;
        flex-direction: column;
        padding: 15px;
        &:last-child {
            .divider {
                display: none;
            }
        }
    }
    .battle-stage-game__name {
        font-size: 20px;
        align-self: flex-start;
        margin-bottom: 20px;
        font-weight: 500;
        @media screen and (max-width: 576px) {
            font-size: 16px;
        }
    }
    .battle-footer {
        text-align: center;
        margin: 30px;
        a {
            text-decoration: underline;
            color: #2187ff;
            &:hover {
                text-decoration: none;
            }
        }
    }
</style>
